// extracted by mini-css-extract-plugin
export default {"amazonPayModeSection":"N3-z"};